// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:17
import { EventGroup_abstract } from './../abstract/SagaSchema/EventGroup_abstract';
export class EventGroup extends EventGroup_abstract {}
